import { render, staticRenderFns } from "./sessionPosStatistics.vue?vue&type=template&id=8a3e5fec"
import script from "./sessionPosStatistics.vue?vue&type=script&lang=js"
export * from "./sessionPosStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports